// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"meditationwithpurpose_scrollbar__2BnNO"};